import React, { Component, Fragment } from "react";
import "./TourUserAssignment.css";
import SvgIcon from "react-icons-kit";
import { u1F1F5 } from "react-icons-kit/noto_emoji_regular/u1F1F5"; //P
import { u1F1F8 } from "react-icons-kit/noto_emoji_regular/u1F1F8"; //S
import { themeService } from "../../../theme/service/activeTheme.service";
import { locationListStyle } from "../../LocationSetup/LocationListStyle";
import { cross } from "react-icons-kit/icomoon/cross";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { languageService } from "../../../Language/language.service";
class TourUserAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableUsers: [],
      primaryUsers: [],
      secondaryUsers: [],
      searchQuery: "",
    };
  }

  componentDidMount() {
    this.initializeLists(this.props.allUsers, this.props.prmUsers, this.props.scndUsers);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allowEdit !== this.props.allowEdit) {
      this.setState({ searchQuery: "" });
    }
    if (
      prevProps.allUsers !== this.props.allUsers ||
      prevProps.prmUsers !== this.props.prmUsers ||
      prevProps.scndUsers !== this.props.scndUsers ||
      prevProps.allowEdit !== this.props.allowEdit
    ) {
      this.initializeLists(this.props.allUsers, this.props.prmUsers, this.props.scndUsers);
    }
  }

  initializeLists = (allUsers, prmUsers, scndUsers) => {
    const prmUserIds = prmUsers || [];
    const scndUserIds = scndUsers || [];

    const assignedUserIds = new Set([...prmUserIds, ...scndUserIds]);

    const availableUsers = (allUsers || []).filter((user) => !assignedUserIds.has(user._id));
    const primaryUsers = (allUsers || []).filter((user) => prmUserIds.includes(user._id));
    const secondaryUsers = (allUsers || []).filter((user) => scndUserIds.includes(user._id));

    this.setState({
      availableUsers,
      primaryUsers,
      secondaryUsers,
    });
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  onDragStart = (e, user, sourceList) => {
    if (!this.props.allowEdit) return;
    e.dataTransfer.setData("user", JSON.stringify(user));
    e.dataTransfer.setData("sourceList", sourceList);
  };

  onDragOver = (e) => {
    e.preventDefault();
  };

  onDrop = (e, destinationList) => {
    if (!this.props.allowEdit) return;
    const user = JSON.parse(e.dataTransfer.getData("user"));
    const sourceList = e.dataTransfer.getData("sourceList");

    if (sourceList === destinationList) {
      return;
    }

    if (
      (destinationList === "primary" && this.state.secondaryUsers.find((u) => u._id === user._id)) ||
      (destinationList === "secondary" && this.state.primaryUsers.find((u) => u._id === user._id))
    ) {
      if (sourceList === "available") return;
    }

    this.moveUser(user, sourceList, destinationList);
  };

  moveUser = (user, source, destination) => {
    if (!this.props.allowEdit) return;
    let { availableUsers, primaryUsers, secondaryUsers } = this.state;

    const removeFromList = (list, userId) => list.filter((u) => u._id !== userId);

    if (source === "available") {
      availableUsers = removeFromList(availableUsers, user._id);
    } else if (source === "primary") {
      primaryUsers = removeFromList(primaryUsers, user._id);
    } else {
      secondaryUsers = removeFromList(secondaryUsers, user._id);
    }

    if (destination === "available") {
      availableUsers = [...availableUsers, user];
    } else if (destination === "primary") {
      secondaryUsers = removeFromList(secondaryUsers, user._id);
      primaryUsers = [...primaryUsers, user];
    } else {
      primaryUsers = removeFromList(primaryUsers, user._id);
      secondaryUsers = [...secondaryUsers, user];
    }

    this.setState({ availableUsers, primaryUsers, secondaryUsers }, () => {
      this.props.onUserAssignmentChange(this.state.primaryUsers, this.state.secondaryUsers);
    });
  };

  renderUserList = (users, listName, title) => {
    const { allowEdit } = this.props;
    const { searchQuery } = this.state;
    const filteredUsers =
      listName === "available" ? users.filter((user) => user.name && user.name.toLowerCase().includes(searchQuery.toLowerCase())) : users;

    return (
      <div onDragOver={this.onDragOver} onDrop={(e) => this.onDrop(e, listName)} className={`user-list-container ${listName}`}>
        <h5 style={{ ...(listName === "primary" ? { color: "#1e7e34" } : {}), ...(listName === "secondary" ? { color: "#0056b3" } : {}) }}>
          <strong>{title}</strong>
        </h5>
        {listName === "available" && (
          <input
            type="text"
            placeholder={languageService("Search available users...")}
            onChange={this.handleSearchChange}
            className="user-search-input"
            disabled={!this.props.allowEdit}
          />
        )}
        <div className="user-list-content">
          {filteredUsers.map((user) => (
            <div
              key={user._id}
              draggable={allowEdit}
              onDragStart={(e) => this.onDragStart(e, user, listName)}
              className={`user-item ${allowEdit ? "draggable" : "not-draggable"}`}
            >
              <span
                style={{
                  marginBlock: "5px",
                }}
              >
                {user.name}
              </span>
              {allowEdit && (
                <div className="user-buttons">
                  {listName === "available" && (
                    <Fragment>
                      <span
                        className="user-list-primaryButton"
                        style={{ ...themeService(locationListStyle.saveInputIcon) }}
                        onClick={() => this.moveUser(user, "available", "primary")}
                      >
                        <TooltipContainer tooltipText={languageService("Primary")}>
                          <SvgIcon style={{ verticalAlign: "middle" }} icon={u1F1F5} size="15" />
                        </TooltipContainer>
                      </span>
                      <span
                        className="user-list-secondaryButton"
                        style={{ ...themeService(locationListStyle.saveInputIcon) }}
                        onClick={() => this.moveUser(user, "available", "secondary")}
                      >
                        <TooltipContainer tooltipText={languageService("Secondary")}>
                          <SvgIcon style={{ verticalAlign: "middle" }} icon={u1F1F8} size="15" />
                        </TooltipContainer>
                      </span>
                    </Fragment>
                  )}
                  {listName !== "available" && (
                    <span
                      className="user-list-deleteButton"
                      style={{ ...themeService(locationListStyle.saveInputIcon) }}
                      onClick={() => this.moveUser(user, listName, "available")}
                    >
                      {" "}
                      <TooltipContainer tooltipText={languageService("Remove")}>
                        <SvgIcon style={{ verticalAlign: "middle" }} icon={cross} size="12" />
                      </TooltipContainer>
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
          {filteredUsers.length === 0 && <p className="no-users-message">{languageService("No users")}</p>}
        </div>
      </div>
    );
  };

  render() {
    const { availableUsers, primaryUsers, secondaryUsers } = this.state;
    const { allowEdit } = this.props;
    return (
      <div className="tour-user-assignment-container">
        <div className="user-assignment-heading" style={{ display: "flex", justifyContent: "space-between" }}>
          <label>
            <strong>{languageService("User Assignment")}</strong>
          </label>
          <br />
          <div style={{ fontSize: "10px", fontWeigh: "600" }}>
            {languageService(" * Click on")} <strong style={{ color: "#1e7e34" }}>P</strong>,{" "}
            <strong style={{ color: "#0056b3" }}>S</strong> {languageService("for User Assignment")}
            <br />
            {languageService("* Drag and Drop for User Assignment")}
          </div>
        </div>
        {allowEdit ? (
          <div style={{ display: "flex", flexDirection: "row", height: "100vh", gap: "10px" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "50%", height: "100%" }}>
              <div style={{ height: "100%" }}>{this.renderUserList(availableUsers, "available", "Available Users")}</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "50%", height: "100%", gap: "10px" }}>
              <div style={{ height: "35%" }}>{this.renderUserList(primaryUsers, "primary", languageService("Primary Users"))}</div>
              <div style={{ height: "65%" }}>{this.renderUserList(secondaryUsers, "secondary", languageService("Secondary Users"))}</div>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "row", height: "100vh", gap: "10px" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "50%", height: "100%", gap: "10px" }}>
              <div style={{ height: "100%" }}>{this.renderUserList(primaryUsers, "primary", languageService("Primary Users"))}</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "50%", height: "100%", gap: "10px" }}>
              <div style={{ height: "100%" }}>{this.renderUserList(secondaryUsers, "secondary", languageService("Secondary Users"))}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TourUserAssignment;



// WEBPACK FOOTER //
// ./src/components/Tour/TourDetails/TourUserAssignment.jsx